import { useMutation } from '@tanstack/react-query';
import { getAuthModule } from '../install';
export function useSignUp() {
    return useMutation({
        mutationFn: (input) => getAuthModule().actions.signUp(input),
    });
}
